import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-terms-modal',
  template: `
    <nb-card style="width: 800px; max-height: 90vh;">
      <nb-card-header>
        <h2>Condiciones de Uso</h2>
      </nb-card-header>
      <nb-card-body class="terms-content">
        <div [innerHTML]="termsContent"></div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton status="success" size="small" (click)="close()">Cerrar</button>
      </nb-card-footer>
    </nb-card>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    nb-card {
      max-width: 100%;
    }
    .terms-content {
      max-height: 60vh;
      overflow-y: auto;
      padding: 1.5rem;
      background-color: #f9f9f9;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
    }
    .terms-content ::ng-deep {
      h1, h2, h3 {
        margin-top: 1.5rem;
        margin-bottom: 0.75rem;
        color: #333;
        font-weight: 600;
      }
      h1 {
        font-size: 1.5rem;
        border-bottom: 2px solid #4CAF50;
        padding-bottom: 0.5rem;
      }
      h2 {
        font-size: 1.25rem;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0.25rem;
      }
      h3 {
        font-size: 1.1rem;
        color: #555;
      }
      p {
        line-height: 1.7;
        margin-bottom: 0.75rem;
        color: #555;
      }
      li {
        line-height: 1.7;
        margin-bottom: 0.5rem;
        color: #555;
      }
      ul, ol {
        margin-left: 1.5rem;
        margin-bottom: 0.75rem;
      }
      strong {
        color: #333;
        font-weight: 600;
      }
      em {
        color: #666;
        font-style: italic;
      }
      hr {
        margin: 1.5rem 0;
        border: none;
        border-top: 2px solid #ddd;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 1rem 0;
      }
      th, td {
        border: 1px solid #ddd;
        padding: 0.75rem;
        text-align: left;
      }
      th {
        background-color: #f0f0f0;
        font-weight: 600;
      }
    }
  `]
})
export class TermsModalComponent {
  @Input() termsContent: string = '';

  constructor(
    protected dialogRef: NbDialogRef<TermsModalComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
